module.exports = __webpack_public_path__ + "static/img/stop.07a70a90.png";